<template>
  <div class="sr-page">
    <div class="sr-card">
      <div class="sr-icon" :class="expired ? 'sr-icon--expired' : 'sr-icon--lock'">
        <i class="pi" :class="expired ? 'pi-clock' : 'pi-lock'"></i>
      </div>

      <h1 class="sr-title">{{ expired ? 'انتهى اشتراكك' : 'الاشتراك مطلوب' }}</h1>
      <p class="sr-text">
        {{ expired
          ? 'انتهت صلاحية اشتراكك في هذا المحتوى. جدّد اشتراكك لاستعادة الوصول الكامل.'
          : 'هذا المحتوى متاح للمشتركين فقط. اشترك الآن للوصول إلى الحصص، الفيديوهات، الملفات، الامتحانات وبنك الأسئلة.' }}
      </p>

      <div v-if="label" class="sr-product"><i class="pi pi-bookmark"></i> {{ label }}</div>

      <div class="sr-actions">
        <button class="sr-btn sr-btn--grad" @click="goSubscribe">
          <i class="pi pi-bolt"></i> {{ expired ? 'جدّد الاشتراك' : 'اشترك الآن' }}
        </button>
        <button class="sr-btn sr-btn--ghost" @click="browse">
          <i class="pi pi-th-large"></i> تصفّح الباقات
        </button>
      </div>

      <button v-if="returnUrl" class="sr-back" @click="$router.replace(returnUrl)">
        <i class="pi pi-arrow-right"></i> رجوع
      </button>
    </div>
  </div>
</template>

<script>
import { normalizeSubscribableType } from '@/composables/subscriptionMeta.js';

export default {
  name: 'SubscriptionRequired',
  computed: {
    type() { return this.$route.query.type || null; },
    id() { return this.$route.query.id || null; },
    label() { return this.$route.query.label || null; },
    returnUrl() { return this.$route.query.return || null; },
    expired() { return this.$route.query.mode === 'expired'; },
  },
  methods: {
    goSubscribe() {
      if (this.type && this.id) {
        this.$router.push({ path: '/subscribe', query: { type: this.type, id: this.id, return: this.returnUrl || undefined } });
      } else {
        this.browse();
      }
    },
    browse() {
      // Normalise so "academicyear"/"academic_year" both browse academic years.
      this.$router.push(normalizeSubscribableType(this.type) === 'academic_year' ? '/academic-years' : '/courses');
    },
  },
};
</script>

<style scoped>
.sr-page { min-height: 70vh; display: flex; align-items: center; justify-content: center; padding: 2rem 1rem 5rem; }
.sr-card {
  background: #fff; border: 1px solid rgba(91,95,239,.1); border-radius: 22px;
  padding: 2.5rem 1.8rem; max-width: 460px; width: 100%; text-align: center;
  box-shadow: 0 12px 40px rgba(91,95,239,.1);
}
.sr-icon {
  width: 88px; height: 88px; border-radius: 50%; margin: 0 auto 1.4rem;
  display: flex; align-items: center; justify-content: center; font-size: 2.4rem;
}
.sr-icon--lock { background: rgba(91,95,239,.1); color: #5B5FEF; }
.sr-icon--expired { background: rgba(239,68,68,.1); color: #ef4444; }
.sr-title { font-size: 1.5rem; font-weight: 800; color: #111827; margin-bottom: .6rem; }
.sr-text { color: #6B7280; line-height: 1.9; font-size: .95rem; }
.sr-product {
  display: inline-flex; align-items: center; gap: .4rem; margin: 1rem 0 0;
  background: rgba(91,95,239,.07); color: #5B5FEF; border-radius: 99px; padding: .4rem 1rem; font-weight: 700; font-size: .85rem;
}
.sr-actions { display: flex; flex-direction: column; gap: .6rem; margin-top: 1.75rem; }
.sr-btn {
  border: none; border-radius: 12px; padding: .8rem 1rem; font-weight: 800; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center; gap: .5rem; font-size: .95rem;
}
.sr-btn--grad { background: linear-gradient(90deg, #5B5FEF, #7c4dff); color: #fff; }
.sr-btn--ghost { background: #f1f5f9; color: #374151; }
.sr-back { background: none; border: none; color: #94a3b8; margin-top: 1.2rem; cursor: pointer; font-weight: 700; }
</style>
